import React, { createContext, useReducer } from "react";
import { initialState } from "./initialState";
import { rootReducer, updatedState, combineActions } from "./componentsLoaded";

const StoreContext = createContext();

const StoreProvider = ({ children }) => {
  const [initState, dispatch] = useReducer(rootReducer, initialState);

  const state = updatedState(initState, dispatch);

  const actions = combineActions(dispatch, state);

  return (
    <StoreContext.Provider value={{ state, actions }}>
      {children}
    </StoreContext.Provider>
  );
};

export { StoreContext, StoreProvider };
